import type { MultiLineChartPoint } from "@/shared/charts";
import type {
  AnalyticsQueueThreshold,
  QueueDataPointStatus,
  QueueQualityReason,
} from "@situate/contracts/runtime";
import type { LiveViewQueue } from "@/features/deployment-dashboard/live-view/model/queue";

export type QueueTrendGranularity = "two-minute" | "hour" | "day";

export interface QueueWaitTrendPoint {
  period: string;
  timestamp: string;
  averageWaitMinutes: number | null;
  peakWaitMinutes: number | null;
  waitDataStatus?: QueueDataPointStatus;
  waitQualityReasons?: QueueQualityReason[];
  nearEmptyWait?: boolean;
}

export interface QueueWaitTrendData {
  queue: LiveViewQueue;
  points: QueueWaitTrendPoint[];
  thresholds?: AnalyticsQueueThreshold[];
}

export interface QueueWaitSummary {
  averageWaitMinutes: number | null;
  peakWaitMinutes: number | null;
}

export const AVERAGE_QUEUE_WAIT_SERIES_ID = "average-queue-wait";
export const PEAK_QUEUE_WAIT_SERIES_ID = "peak-queue-wait";

export function toQueueWaitChartData(data: QueueWaitTrendData): MultiLineChartPoint[] {
  return data.points.map((point) => ({
    x: point.period,
    timestamp: point.timestamp,
    values: {
      [AVERAGE_QUEUE_WAIT_SERIES_ID]: point.averageWaitMinutes,
      [PEAK_QUEUE_WAIT_SERIES_ID]: point.peakWaitMinutes,
    },
  }));
}
